<template>
  <div class="col-md-12">
    <div v-if="currentCountry" class="card card-container">
      <h4><font-awesome-icon icon="edit" /> Edit Country Details</h4>
      <form name="form" @submit.prevent="updateCountry">
        <div v-if="!successful">
          <div class="form-group">
            <label for="code">Code:</label>
            <input v-model="currentCountry.code" v-validate="'required|min:2|max:6'" type="text" class="form-control" id="code" name="code"/>
            <div v-if="submitted && errors.has('code')" class="alert-danger">{{errors.first('code')}}</div>
          </div>
          <div class="form-group">
            <label for="name">Name:</label>
            <input v-model="currentCountry.name" v-validate="'required|min:3|max:75'" type="text" class="form-control" id="name" name="name"/>
            <div v-if="submitted && errors.has('name')" class="alert-danger" >{{errors.first('name')}}</div>
          </div>          
          <div class="form-group">
            <button class="badge badge-danger mr-2" @click="deleteCountry"><font-awesome-icon icon="trash-alt" /> Delete</button>
            <button type="submit" class="badge badge-success mr-2"><font-awesome-icon icon="save" /> Update</button>
            <button class="badge badge-primary" @click="countriesList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      <div v-if="message && successful">
        <button class="btn btn-primary" @click="countriesList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
      </div>
    </div>
    <div v-else>
      <br />
      <p>Please click on a Country...</p>
    </div>
  </div>
</template>

<script>
import CountryService from "../services/country.service";

export default {
  name: 'country',
  data() {
    return {
      currentCountry: null,
      submitted: false,
      successful: false,
      message: '',
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    getCountry(id) {
      CountryService.get(id)
        .then(response => {
          this.currentCountry = response.data;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    updateCountry() {
      this.message = '';
      this.submitted = true;
      this.$validator.validate().then(isValid => {
        if (isValid) {
          CountryService.update(this.currentCountry.id, this.currentCountry).then(
            response => {
              console.log(response.data);
              this.message = 'The country was updated successfully!';
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log(e);
            });
        }
      });
    },

    deleteCountry() {
      CountryService.delete(this.currentCountry.id)
        .then(response => {
          console.log(response.data);
          this.$router.push({ name: "countries" });
        })
        .catch(e => {
          console.log(e);
        });
    },

    countriesList() {
      this.$router.push('/countries');
    }
  },
  mounted() {
    this.message = '';
    this.getCountry(this.$route.params.id);
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>